module.exports = __webpack_public_path__ + "static/media/trailer.1878d0c8.png";